import {
  Truck,
  MoveVertical,
  Construction,
  Hammer,
  Scissors,
  Wind,
  Zap,
  Disc3,
  CircleDashed,
  Cylinder,
  Wrench,
  Forklift,
} from "lucide-react";

// Icon registry — maps iconName (string) to a lucide component
export const iconMap = {
  Truck,
  MoveVertical,
  Construction,
  Hammer,
  Scissors,
  Wind,
  Zap,
  Disc3,
  CircleDashed,
  Cylinder,
  Forklift,
};

export const getIcon = (name) => iconMap[name] || Wrench;
